module.exports = __webpack_public_path__ + "img/160.5fa2ecae.jpeg";